import api from "@/lib/api";
import type { PaginatedResponse } from "@/types/common/api-types";
import type {
  StaffRosterOverrideCreate,
  StaffRosterOverrideRead,
  StaffRosterOverrideSearchParams,
  StaffRosterOverrideUpdate,
} from "@/types/staff/api-types/staff-roster-override-types";

export const staffRosterOverridesApi = {
  getAll: async (
    params: StaffRosterOverrideSearchParams = {}
  ): Promise<PaginatedResponse<StaffRosterOverrideRead>> => {
    const response = await api.get<PaginatedResponse<StaffRosterOverrideRead>>(
      "/staff-roster-overrides",
      { params }
    );
    return response.data;
  },

  create: async (
    data: StaffRosterOverrideCreate
  ): Promise<StaffRosterOverrideRead> => {
    const response = await api.post<StaffRosterOverrideRead>(
      "/staff-roster-overrides",
      data
    );
    return response.data;
  },

  update: async (
    id: number,
    data: StaffRosterOverrideUpdate
  ): Promise<StaffRosterOverrideRead> => {
    const response = await api.put<StaffRosterOverrideRead>(
      `/staff-roster-overrides/${id}`,
      data
    );
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/staff-roster-overrides/${id}`);
  },
};
